import { useEffect } from "react";

// Título consistente por ruta: "<específico> · Torre de Control".
export const usePageTitle = (titulo) => {
  useEffect(() => {
    document.title = titulo ? `${titulo} · Torre de Control` : "Torre de Control · LOCCITEC";
  }, [titulo]);
};
